import React from 'react';
import PropTypes from 'prop-types';
import { default as content } from '../AddNewPayeeLandingPage/index.content';
import { Checkbox } from '../../../sharedComponents/Form';
import {
	validationPropsProtoTypes,
	ibanFieldPropTypes,
	internationalAccountNumberFieldPropTypes,
	bickOrSwiftFieldPropTypes,
	clearingCodeFieldPropTypes,
} from '../../states/addPayee/propTypes';
import { IBAN, InternationalAccountNumber, BICOrSWIFT, ClearingCode } from './withValidationComponents';
import { addPayeeFormLengths } from '../../../../src/config';

const PayeeAccountDetails = ({
	validationProps,
	iban,
	internationalAccountNumber,
	payeeAccountType,
	bickOrSwift,
	clearingCode,
	noBicOrSwift,
	noBicOrSwiftChange,
}) => {
	const {
		BICOrSWIFTLabel,
		BICOrSWIFTDescription,
		clearingCodeLabel,
		clearingCodeDescription,
		noBicOrSwiftLabel,
		IBANLabel,
		accountNumberLabel,
	} = content;
	const { bickOrSwiftMaxLength, bickOrSwiftMinLength } = addPayeeFormLengths;

	if (payeeAccountType === 'iban') {
		return (
			<span>
				<IBAN {...iban} {...validationProps} type="text" label={IBANLabel} />
			</span>
		);
	}
	return (
		<span>
			<InternationalAccountNumber
				{...internationalAccountNumber}
				{...validationProps}
				type="text"
				label={accountNumberLabel}
			/>
			<BICOrSWIFT
				{...bickOrSwift}
				{...validationProps}
				label={BICOrSWIFTLabel}
				description={BICOrSWIFTDescription}
				disabled={noBicOrSwift}
				type="text"
				useValidation={!noBicOrSwift}
				maxLength={bickOrSwiftMaxLength}
				minLength={bickOrSwiftMinLength}
				{...validationProps}
			>
				<Checkbox id="noBicOrSwift" label={noBicOrSwiftLabel} onChange={noBicOrSwiftChange} checked={noBicOrSwift} />
			</BICOrSWIFT>
			<ClearingCode
				{...validationProps}
				{...clearingCode}
				label={clearingCodeLabel}
				description={clearingCodeDescription}
				type="text"
				onChange={validationProps.onChange}
				useValidation={!!noBicOrSwift}
			/>
		</span>
	);
};

PayeeAccountDetails.propTypes = {
	validationProps: PropTypes.shape(validationPropsProtoTypes).isRequired,
	iban: PropTypes.shape(ibanFieldPropTypes).isRequired,
	internationalAccountNumber: PropTypes.shape(internationalAccountNumberFieldPropTypes).isRequired,
	payeeAccountType: PropTypes.string.isRequired,
	bickOrSwift: PropTypes.shape(bickOrSwiftFieldPropTypes).isRequired,
	clearingCode: PropTypes.shape(clearingCodeFieldPropTypes).isRequired,
	noBicOrSwift: PropTypes.bool,
	noBicOrSwiftChange: PropTypes.func.isRequired,
};

export default PayeeAccountDetails;
